import { useEffect, useState } from "react";

/** The device's time, in its own locale and 12/24-hour preference. */
export function formatClock(date: Date): string {
  return date.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
}

/** The day, in the device's own locale and short form ("Mon, Oct 14"). */
export function formatDate(date: Date): string {
  return date.toLocaleDateString([], { weekday: "short", month: "short", day: "numeric" });
}

/**
 * The system clock, top right of the full-screen player (owner 2026-09-18:
 * "TVs have clocks"). Shown with the controls and fades out with them. Ticks
 * on the minute boundary, so it never lags the TV's own clock by up to a minute
 * — and the date under it turns over at midnight by itself.
 */
export function PlayerClock() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    const schedule = () => {
      const current = new Date();
      setNow(current);
      timer = setTimeout(schedule, 60_000 - (current.getSeconds() * 1000 + current.getMilliseconds()) + 50);
    };
    schedule();
    return () => clearTimeout(timer);
  }, []);

  const date = formatDate(now);

  return (
    <time className="player-surface__clock" dateTime={now.toISOString()} aria-label={`Time ${formatClock(now)}, ${date}`}>
      {formatClock(now)}
      <span className="player-surface__date">{date}</span>
    </time>
  );
}
